module.exports = __webpack_public_path__ + "static/media/tal.2bd3e539.jpg";